import React from "react";
import { RestrictedAreas } from "@planzone/dto";
import { Props } from "./types";
import { useRestrictedArea } from "./utils";

function RestrictedArea<RA extends RestrictedAreas[]>({
  areas,
  children,
}: Props<RA>) {
  const accesses = useRestrictedArea(areas);

  return <>{children(accesses)}</>;
}

export { RestrictedArea };
